import React from 'react';

import CoreMenuHomePage from 'src/dispensary/core-menu/home';
import { getDispensaryServerSideProps } from 'src/utils/ssr/get-dispensary-server-side-props';
import { CoreMenuLayout } from 'components/layouts/core-menu-layout';
import { withLayout } from 'src/components/layouts/with-layout';
import { StorefrontBootstrapProvider } from 'src/dispensary/context/storefront-bootstrap-context';

export const getServerSideProps = getDispensaryServerSideProps;

const StorefrontBootstrapCoreMenuLayout = (props) => (
  <StorefrontBootstrapProvider>
    <CoreMenuLayout {...props} />
  </StorefrontBootstrapProvider>
);

export default withLayout(CoreMenuHomePage, StorefrontBootstrapCoreMenuLayout);
